import React, { useState } from "react";

function ShareIcon() {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      className="share-icon"
    >
      <circle cx="18" cy="5" r="3" />
      <circle cx="6" cy="12" r="3" />
      <circle cx="18" cy="19" r="3" />
      <line x1="8.59" y1="13.51" x2="15.42" y2="17.49" />
      <line x1="15.41" y1="6.51" x2="8.59" y2="10.49" />
    </svg>
  );
}

/**
 * Native share (Web Share API) with a clipboard-copy fallback for browsers
 * that don't support it (most desktop browsers as of writing — this is a
 * mobile-first API). Nothing here is sent to any server; navigator.share
 * hands off to the OS share sheet, and the clipboard fallback runs
 * entirely client-side.
 */
export default function ShareButton({ title, text, url, className = "" }) {
  const [copied, setCopied] = useState(false);
  const canNativeShare = typeof navigator !== "undefined" && !!navigator.share;

  const copyFallback = async () => {
    try {
      await navigator.clipboard.writeText(url);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (e) {
      // Clipboard API unavailable (old browser, non-HTTPS context) — nothing
      // more to do silently; the URL is still visible wherever this sits.
    }
  };

  const handleShare = async () => {
    if (canNativeShare) {
      try {
        await navigator.share({ title, text, url });
      } catch (err) {
        // AbortError just means the person closed the share sheet — not a
        // failure. Only fall back to clipboard on a genuine other error.
        if (err && err.name !== "AbortError") {
          await copyFallback();
        }
      }
      return;
    }
    await copyFallback();
  };

  return (
    <button type="button" className={`share-button ${className}`} onClick={handleShare}>
      <ShareIcon />
      {copied ? "Copied!" : canNativeShare ? "Share" : "Copy link"}
    </button>
  );
}
